// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.board {
    position: relative;
    top: 100px;
    height: 88%;
    width: 90%;
    background: var(--public-portal-card);
    border-radius: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    margin: auto;
    padding: 1rem;

    -webkit-box-shadow: 0px 6px 6px #d4dae0;
    -moz-box-shadow: 0px 6px 6px #d4dae0;
    box-shadow: 0px 6px 6px #d4dae0;
}

.board::-webkit-scrollbar {
    width: 10px;
}

.board::-webkit-scrollbar-thumb {
    background: rgba(128, 128, 128, 0.4);
    border-radius: 15px;
}

.board::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 15px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.board-header {
    padding: 1rem 0rem 1rem 0rem;
    text-align: center;
}

.board-header h1 {
    font-size: 1.5rem;
    color: #333333;
}

@media (min-width: 800px) {
    .board-header {
        padding: 2rem 0rem 2rem 0rem;
    }

    .board-header h1 {
        font-size: 2rem;
    }
}

.small-board {
    padding: 3px 3px 2rem 3px;
    top: 250px;
    width: 30%;
    min-height: 30%;
    max-height: 70%;
    height: fit-content;
    overflow-y: visible;
}

.small-board-header {
    height: 4rem;
    margin-bottom: 2rem;
    color: var(--public-portal-card);
    border-radius: 15px 15px 0 0;
    box-shadow: 0px 6px 6px #d4dae0;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* \$\$\$\$\$\$\$\$\$\$\$\$ MEDIA QUERY SMALL \$\$\$\$\$\$\$\$\$\$\$\$ */

@media only screen and (max-width: 600px) {
    .board {
        height: calc(85% - 70px);
    }
}

@media (max-width: 1300px) {
    .small-board {
        width: 55%;
    }
}

@media (max-width: 700px) {
    .small-board {
        width: 80%;
    }

    .small-board-header h1 {
        font-size: 1.75rem;
    }
}

@media (max-width: 400px) {
    .small-board {
        width: 90%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/board/Board.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;;IAEb,uCAAuC;IACvC,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,UAAU;IACV,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,4BAA4B;IAC5B,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,gDAAgD;;AAEhD;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ","sourcesContent":[".board {\n    position: relative;\n    top: 100px;\n    height: 88%;\n    width: 90%;\n    background: var(--public-portal-card);\n    border-radius: 15px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    margin: auto;\n    padding: 1rem;\n\n    -webkit-box-shadow: 0px 6px 6px #d4dae0;\n    -moz-box-shadow: 0px 6px 6px #d4dae0;\n    box-shadow: 0px 6px 6px #d4dae0;\n}\n\n.board::-webkit-scrollbar {\n    width: 10px;\n}\n\n.board::-webkit-scrollbar-thumb {\n    background: rgba(128, 128, 128, 0.4);\n    border-radius: 15px;\n}\n\n.board::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 15px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.board-header {\n    padding: 1rem 0rem 1rem 0rem;\n    text-align: center;\n}\n\n.board-header h1 {\n    font-size: 1.5rem;\n    color: #333333;\n}\n\n@media (min-width: 800px) {\n    .board-header {\n        padding: 2rem 0rem 2rem 0rem;\n    }\n\n    .board-header h1 {\n        font-size: 2rem;\n    }\n}\n\n.small-board {\n    padding: 3px 3px 2rem 3px;\n    top: 250px;\n    width: 30%;\n    min-height: 30%;\n    max-height: 70%;\n    height: fit-content;\n    overflow-y: visible;\n}\n\n.small-board-header {\n    height: 4rem;\n    margin-bottom: 2rem;\n    color: var(--public-portal-card);\n    border-radius: 15px 15px 0 0;\n    box-shadow: 0px 6px 6px #d4dae0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* $$$$$$$$$$$$ MEDIA QUERY SMALL $$$$$$$$$$$$ */\n\n@media only screen and (max-width: 600px) {\n    .board {\n        height: calc(85% - 70px);\n    }\n}\n\n@media (max-width: 1300px) {\n    .small-board {\n        width: 55%;\n    }\n}\n\n@media (max-width: 700px) {\n    .small-board {\n        width: 80%;\n    }\n\n    .small-board-header h1 {\n        font-size: 1.75rem;\n    }\n}\n\n@media (max-width: 400px) {\n    .small-board {\n        width: 90%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
